export default __webpack_public_path__ + "static/jinhwanchoi.jiyoung.chae-f352195b7915e6eaac0ea2b0530ccf35.jpeg";